import { bcSessionKeys } from './../common/constants/session-keys';
import { WorkItem } from './interfaces/workitem-base.interface';
import { Injectable } from '@angular/core';
import { CoolLocalStorage } from '@angular-cool/storage';
import { WorkItemStateHandler } from 'shared/services/workitem-state-handler/workitem-state-handler.service';

@Injectable()
export class WorkAreaManager {
  private expandedMode?: boolean;

  constructor(private localStorageService: CoolLocalStorage,
              private _workItemStateHandler: WorkItemStateHandler) {
    const loadedExpandedMode = this.localStorageService.getItem(bcSessionKeys.storage.expandedMode);

    if (loadedExpandedMode !== null) {
      this.expandedMode = JSON.parse(loadedExpandedMode);
    } else {
      this.toggleExpandedMode();
    }
  }

  getSelectedWorkItem(): WorkItem {
    return this._workItemStateHandler.getFocusedWorkItem();
  }

  get openedWorkItemsList(): WorkItem[] {
    return this._workItemStateHandler.getOpenWorkItems();
  }

  removeWorkItem(workItemId: string): void {
    this._workItemStateHandler.selectNextWorkItem();
    this._workItemStateHandler.closeWorkItem(workItemId);
  }

  focusWorkItem(workItemId: string): void {
    this._workItemStateHandler.focusWorkItem(workItemId);
  }

  isExpandedMode(): boolean | undefined {
    return this.expandedMode;
  }

  toggleExpandedMode(): void {
    this.expandedMode = !this.expandedMode;
    this.localStorageService.setItem(bcSessionKeys.storage.expandedMode, this.expandedMode.toString());
  }
}
